import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-evaluate-after-modal',
  templateUrl: './evaluate-after-modal.component.html',
  styleUrls: ['./evaluate-after-modal.component.scss'],
})
export class EvaluateAfterModalComponent implements OnInit {
  constructor(private modalRef: MatDialogRef<EvaluateAfterModalComponent>) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.close();
    }, 2000);
  }

  close(r: any = null) {
    this.modalRef.close(r);
  }
}
